import React, { useEffect, useRef, useState } from "react";

// Hook para animar el contador
function useCountUp(end: number, duration = 1200) {
  const [count, setCount] = useState(0);
  const ref = useRef<number | null>(null);
  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16);
    function step() {
      start += increment;
      if (start < end) {
        setCount(Math.floor(start));
        ref.current = requestAnimationFrame(step);
      } else {
        setCount(end);
        if (ref.current !== null) cancelAnimationFrame(ref.current);
      }
    }
    ref.current = requestAnimationFrame(step);
    return () => {
      if (ref.current !== null) cancelAnimationFrame(ref.current);
    };
  }, [end, duration]);
  return count;
}

const Home = () => {
  // Contadores animados
  const countClients = useCountUp(600);
  const countLoads = useCountUp(120);
  const countSecurity = useCountUp(100);
  return (
    <div className="min-h-screen bg-gray-50 overflow-x-hidden">
  {/* Navbar global se debe mostrar desde el layout o App.tsx */}
      {/* Hero Section */}
      <main>
  <section className="relative w-full h-full text-white overflow-x-hidden min-h-screen flex items-center mt-0" style={{ minHeight: 'calc(-4rem + 110vh)' }} data-aos="fade-up">
          <img alt="Camión Royal Trucking" className="absolute inset-0 w-full h-full object-cover object-center z-0" loading="lazy" src="/camion.webp" style={{ filter: 'brightness(0.55)', objectPosition: 'center center' }} />
          <div className="absolute inset-0 bg-gradient-to-r from-orange-900/80 to-orange-700/70 z-10"></div>
          <img alt="Royal Trucking Hero" className="hidden lg:block absolute left-2/3 bottom-0 transform -translate-x-1/2 h-[520px] max-w-full w-auto z-20 pointer-events-none select-none" loading="lazy" src="/fondohome.webp" style={{ maxWidth: '100vw', objectFit: 'contain' }} />
          <div className="relative z-30 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32 pt-40 flex items-center min-h-[calc(100vh-4rem)]">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-4xl lg:text-6xl font-bold mb-2">Bienvenidos a Royal Trucking</h1>
                <p className="text-lg mb-8 text-orange-100 font-semibold">Soluciones integrales en transporte de carga y logística a nivel nacional.</p>
                <div className="flex flex-col sm:flex-row gap-4 mb-8">
                  <a className="bg-orange-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-800 transition-colors duration-200 text-center" href="/services">Servicios</a>
                  <a className="border-2 border-orange-700 text-orange-700 px-8 py-3 rounded-lg font-semibold hover:bg-orange-700 hover:text-white transition-colors duration-200 text-center" href="/contact">Contacto</a>
                </div>
                <div className="flex flex-col sm:flex-row gap-8 mt-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-300"><span>{countClients}+</span></div>
                    <div className="text-orange-100">Clientes Satisfechos</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-300"><span>{countLoads}+</span></div>
                    <div className="text-orange-100">Cargas Transportadas</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-300"><span>{countSecurity}%</span></div>
                    <div className="text-orange-100">Seguridad Garantizada</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Beneficios */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16" data-aos="fade-up">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">¿Por qué elegir Royal Trucking?</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">Somos una empresa de transporte netamente peruana, especializada en el traslado de carga por carretera de mercadería suelta y paletizada.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center p-6 rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors" data-aos="fade-up" data-aos-delay="0">
                <div className="w-16 h-16 bg-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                </div>
                <h3 className="text-xl font-semibold mb-3">Seguridad Garantizada</h3>
                <p className="text-gray-600">Tu carga está protegida con seguro y monitoreo constante.</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors" data-aos="fade-up" data-aos-delay="100">
                <div className="w-16 h-16 bg-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                </div>
                <h3 className="text-xl font-semibold mb-3">Cobertura Nacional</h3>
                <p className="text-gray-600">Llegamos a todo el Perú, incluso a los lugares más recónditos.</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors" data-aos="fade-up" data-aos-delay="200">
                <div className="w-16 h-16 bg-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                </div>
                <h3 className="text-xl font-semibold mb-3">Atención Personalizada</h3>
                <p className="text-gray-600">Soluciones a medida y soporte en todo momento.</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors" data-aos="fade-up" data-aos-delay="300">
                <div className="w-16 h-16 bg-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                </div>
                <h3 className="text-xl font-semibold mb-3">Experiencia y Confianza</h3>
                <p className="text-gray-600">Más de 120 cargas transportadas y 6,000 clientes satisfechos.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Logos de clientes */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-900 text-center mb-10" data-aos="fade-up">Confían en nosotros</h2>
            <div className="flex flex-wrap justify-center items-center gap-8">
              <img alt="Cliente 1" className="h-16 w-auto grayscale hover:grayscale-0 transition duration-300 bg-white rounded-lg shadow p-2" src="/cliente1.webp" data-aos="zoom-in" data-aos-delay="0" />
              <img alt="Cliente 2" className="h-16 w-auto grayscale hover:grayscale-0 transition duration-300 bg-white rounded-lg shadow p-2" src="/cliente2.webp" data-aos="zoom-in" data-aos-delay="100" />
              <img alt="Cliente 3" className="h-16 w-auto grayscale hover:grayscale-0 transition duration-300 bg-white rounded-lg shadow p-2" src="/cliente3.webp" data-aos="zoom-in" data-aos-delay="200" />
              <img alt="Cliente 4" className="h-16 w-auto grayscale hover:grayscale-0 transition duration-300 bg-white rounded-lg shadow p-2" src="/cliente4.webp" data-aos="zoom-in" data-aos-delay="300" />
              <img alt="Cliente 5" className="h-16 w-auto grayscale hover:grayscale-0 transition duration-300 bg-white rounded-lg shadow p-2" src="/cliente5.webp" data-aos="zoom-in" data-aos-delay="400" />
              <img alt="Cliente 6" className="h-16 w-auto grayscale hover:grayscale-0 transition duration-300 bg-white rounded-lg shadow p-2" src="/cliente6.webp" data-aos="zoom-in" data-aos-delay="500" />
            </div>
          </div>
        </section>

        {/* Cómo trabajamos */}
        <section className="py-20 bg-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16" data-aos="fade-up">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">¿Cómo trabajamos?</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">Nuestro proceso es simple, seguro y eficiente para que tu carga llegue siempre a tiempo y en perfectas condiciones.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-lg p-8 text-center" data-aos="fade-up" data-aos-delay="0">
                <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-orange-600">1</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Cotiza tu envío</h3>
                <p className="text-gray-600">Solicita una cotización personalizada según tus necesidades.</p>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-8 text-center" data-aos="fade-up" data-aos-delay="100">
                <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-orange-600">2</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Recojo y traslado</h3>
                <p className="text-gray-600">Recogemos tu carga y la trasladamos con monitoreo 24/7.</p>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-8 text-center" data-aos="fade-up" data-aos-delay="200">
                <div className="w-12 h-12 bg-orange-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-orange-600">3</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Entrega segura</h3>
                <p className="text-gray-600">Entregamos tu carga en el destino acordado, a tiempo y en perfectas condiciones.</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="py-20 bg-orange-700 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">¿Listo para transportar tu carga con Royal Trucking?</h2>
            <p className="text-xl mb-8 text-orange-100 max-w-2xl mx-auto">Contáctanos hoy mismo y descubre por qué somos la mejor opción en transporte de carga por carretera en Perú.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a className="bg-white text-orange-700 px-8 py-3 rounded-lg font-semibold hover:bg-orange-800 hover:text-white transition-colors duration-200" href="/contact">Solicitar Cotización</a>
              <a className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-orange-700 transition-colors duration-200" href="/services">Ver Servicios</a>
            </div>
          </div>
        </section>
      </main>
  {/* Footer global se debe mostrar desde el layout o App.tsx */}
    </div>
  );
};

export default Home;